import React from 'react';

import {assetsBaseUrl} from "../../../services/calculationsApi";


function CheckLine({text}) {
    return (
        <div className="ct-step__sidebar-checkline">
            <div>
                <img src={`${assetsBaseUrl}/assets/svg/check-secondary.svg`} alt=""/>
            </div>

            <div>
                {text}
            </div>
        </div>
    );
}

export default CheckLine;
